import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {
    ZoomIn,
} from '@material-ui/icons';

import {
    Link,
    Table,
    TableColumn,
} from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';

import { useForensicItems } from '../../hooks/useForensicItems';
import { detailRouteRef } from '../../routes';
import { ForensicsItemSummary } from '../../api/types';

const useStyles = makeStyles(theme => ({
    container: {
        width: 850,
    },
    empty: {
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center',
    },
}));


const columns: TableColumn[] = [
    {
        title: 'Timestamp',
        defaultSort: 'desc',
        hidden: true,
        field: 'date',
    },
    {
        title: 'App Version',
        field: 'appVersion',
        sorting: true,
        highlight: true,
        render: (row: Partial<ForensicsItemSummary>) => {
            const LinkWrapper = () => {
                const routeLink = useRouteRef(detailRouteRef);
                return (
                  <Link
                    to={routeLink({
                      itemRef: encodeURIComponent(row.prefix || ''),
                      pod: '-',
                      container: 'main',
                    })}
                  >
                    {row.appVersion}
                  </Link>
                );
              };
        
              return <LinkWrapper />;
        },
    },
    {
        title: 'Timestamp',
        field: 'dateFormatted',
        sorting: false,
    },
    {
        title: 'Cluster',
        field: 'env',
        sorting: true,
    },
    {
        title: 'Namespace',
        field: 'namespace',
        sorting: true,
    },
];

type Props = {
    loading: boolean;
    retry: () => void;
    items?: ForensicsItemSummary[];
    page: number;
    onChangePage: (page: number) => void;
    total: number;
    pageSize: number;
    onChangePageSize: (pageSize: number) => void;
};

export const ForensicsTableView = ({
    loading,
    pageSize,
    page,
    retry,
    items,
    onChangePage,
    onChangePageSize,
    total,
}: Props) => {
    const classes = useStyles();

    const itemsInPage = items?.slice(
        page * pageSize,
        Math.min(items.length, (page + 1) * pageSize),
    );
    return (
        <Table
            isLoading={loading}
            options={{ paging: true, pageSize, padding: 'dense' }}
            totalCount={total}
            page={page}
            emptyContent={
                <div className={classes.empty}>
                    No forensics items found for this application.
                </div>
            }
            data={itemsInPage ?? []}
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangePageSize}
            title="Failed Deployments"
            columns={columns}
        />
    );
};

export const ForensicsTable = () => {
    const [tableProps, { setPage, retry, setPageSize }] = useForensicItems();

    return (
        <ForensicsTableView
            {...tableProps}
            retry={retry}
            onChangePageSize={setPageSize}
            onChangePage={setPage}
        />
    );
};
